export default __webpack_public_path__ + "static/media/212.0d847f6b.png";